import { render, staticRenderFns } from "./branchverifydiff.vue?vue&type=template&id=4e33fb16&scoped=true&"
import script from "./branchverifydiff.vue?vue&type=script&lang=js&"
export * from "./branchverifydiff.vue?vue&type=script&lang=js&"
import style0 from "./branchverifydiff.vue?vue&type=style&index=0&id=4e33fb16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e33fb16",
  null
  
)

export default component.exports